import { render, staticRenderFns } from "./addDistrictAdmin.vue?vue&type=template&id=27b24d22&scoped=true&"
import script from "./addDistrictAdmin.vue?vue&type=script&lang=js&"
export * from "./addDistrictAdmin.vue?vue&type=script&lang=js&"
import style0 from "./addDistrictAdmin.vue?vue&type=style&index=0&id=27b24d22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b24d22",
  null
  
)

export default component.exports